import PythonInstall from "../../../../contents/docs/integrate/_snippets/install-python.mdx";
import PythonSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-python.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import PythonFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-python.mdx";
import LocalEvaluationIntro from "../../../../contents/docs/feature-flags/snippets/local-evaluation-intro.mdx";
import * as React from 'react';
export default {
  PythonInstall,
  PythonSendEvents,
  FeatureFlagsLibsIntro,
  PythonFeatureFlagsCode,
  LocalEvaluationIntro,
  React
};